// components/InfoTooltip.tsx

import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type InfoTooltipProps = {
  message: string;
  size?: 'small' | 'medium' | 'large';
  color?: string;
};

const InfoTooltip: React.FC<InfoTooltipProps> = ({ message, size = 'small', color = 'text-gray-300'  }) => {
  return (
    <Tooltip title={message} arrow>
      <IconButton size={size} className={`!p-0 ${color}`}>
        <InfoOutlinedIcon fontSize={size} sx={{ color: 'white' }} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
